import { ArrowRight, Sparkles } from 'lucide-react';
import { Reveal } from '@/components/system';

interface CTASectionProps {
  onExploreClick: () => void;
}

export function CTASection({ onExploreClick }: CTASectionProps) {
  return (
    <section className="section-y bg-gradient-to-br from-kuiva-blue via-kuiva-blue/95 to-kuiva-green px-3 safe-area-px sm:px-6">
      <Reveal>
        <div className="kuiva-cta-panel-motion mx-auto w-full min-w-0 max-w-3xl rounded-3xl border border-white/50 bg-white/40 px-5 py-8 text-center shadow-[0_16px_48px_rgb(0_0_0/0.14)] backdrop-blur-xl sm:px-8 sm:py-10">
          <div className="mb-4 inline-flex max-w-[min(100%,20rem)] items-center gap-2.5 rounded-full border border-white/90 bg-white px-4 py-2 shadow-[0_4px_20px_rgb(0_0_0/0.12)] backdrop-blur-md sm:mb-5 sm:max-w-none sm:px-5 sm:py-2.5">
            <Sparkles className="h-4 w-4 shrink-0 text-kuiva-blue sm:h-[1.125rem] sm:w-[1.125rem]" aria-hidden />
            <span className="text-left text-[0.8125rem] font-semibold leading-snug text-slate-950 sm:text-center sm:text-sm sm:leading-tight">
              É grátis explorar profissionais
            </span>
          </div>

          <h2 className="mb-3 break-words text-2xl font-bold text-white drop-shadow-sm sm:text-3xl md:text-4xl">
            Dá o primeiro passo
          </h2>

          <p className="mx-auto mb-6 max-w-lg text-base text-white drop-shadow-sm sm:mb-7 sm:text-lg">
            Não esperes mais para cuidares de ti a Kuiva acompanha-te neste caminho.
          </p>

          <button
            type="button"
            onClick={onExploreClick}
            className="group inline-flex items-center gap-2 rounded-full border-2 border-white/90 bg-white px-8 py-3.5 text-base font-semibold text-slate-800 shadow-[0_8px_30px_rgb(0_0_0/0.18)] transition-[transform,box-shadow,background-color,color] duration-500 ease-kuiva hover:scale-[1.02] hover:bg-slate-50 hover:shadow-[0_12px_36px_rgb(0_0_0/0.22)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-slate-700/40 active:scale-[0.98] sm:px-10 sm:py-4"
          >
            Começar agora
            <ArrowRight className="h-5 w-5 text-slate-800 transition-transform duration-500 ease-kuiva group-hover:translate-x-1" />
          </button>
        </div>
      </Reveal>
    </section>
  );
}
